import { Image } from "antd-mobile";

import { CustomCard } from "../../../../components";
import { envChangeType } from "../../../../plugins/utils";
import "./style.scss";

function EventItem({ item, itemOnClick }) {
  return (
    <div className="agent-mobile-event-item">
      <CustomCard onClick={itemOnClick}>
        <Image
          src={`${envChangeType("REACT_APP_CDN_URL")}/${item.img_url}`}
          // height={111}
          // style={{
          //   width: "calc(100vw - 24px)",
          //   height: "calc((100vw - 24px) / var(--banner-width-height-ratio))",
          // }}
          fit="cover"
        />
        <div className="event-title">{item.title}</div>
      </CustomCard>
    </div>
  );
}

export default EventItem;
